/**
 * Ingredients List Tab Navigation
 * Handles tab switching to show different ingredient categories
 */

function initIngredientsTabs(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) {
    console.warn('Ingredients list section not found:', sectionId);
    return;
  }

  const tabs = section.querySelectorAll('.ingredients-list__tab');
  const categories = section.querySelectorAll('.ingredients-category');

  if (tabs.length === 0) {
    // No tabs, show all categories (single category mode)
    categories.forEach((category) => {
      category.classList.remove('ingredients-category--hidden');
    });
    return;
  }

  // Initialize: Show first category, hide others
  categories.forEach((category, index) => {
    if (index === 0) {
      category.classList.remove('ingredients-category--hidden');
    } else {
      category.classList.add('ingredients-category--hidden');
    }
  });

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const categoryId = tab.getAttribute('data-category-id');

      if (!categoryId) {
        console.warn('Tab missing data-category-id attribute');
        return;
      }

      // Get the currently visible category
      const currentCategory = section.querySelector('.ingredients-category:not(.ingredients-category--hidden)');
      const selectedCategory = section.querySelector(
        `.ingredients-category[data-category-id="${categoryId}"]`
      );

      if (!selectedCategory) {
        console.warn('Category not found for ID:', categoryId);
        return;
      }

      // If clicking the same tab, do nothing
      if (currentCategory && currentCategory === selectedCategory) {
        return;
      }

      // Remove active class from all tabs
      tabs.forEach((t) => t.classList.remove('active'));

      // Add active class to clicked tab
      tab.classList.add('active');

      // Fade out current category, then fade in new one
      if (currentCategory && currentCategory !== selectedCategory) {
        // Start fade out
        currentCategory.classList.add('ingredients-category--hidden');
        
        // Wait for fade out to complete, then fade in new category
        setTimeout(() => {
          selectedCategory.classList.remove('ingredients-category--hidden');
        }, 400); // Full transition duration to ensure fade out completes
      } else {
        // No current category or same category, just show the new one
        selectedCategory.classList.remove('ingredients-category--hidden');
      }
    });
  });
}

// Initialize function that can be called multiple times
function initializeAllIngredientsTabs() {
  const sections = document.querySelectorAll('.ingredients-list');
  sections.forEach((section) => {
    const sectionId = section.id;
    if (sectionId && !section.dataset.tabsInitialized) {
      section.dataset.tabsInitialized = 'true';
      initIngredientsTabs(sectionId);
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllIngredientsTabs);
} else {
  // DOM already loaded
  initializeAllIngredientsTabs();
}

// Also handle Shopify theme editor and dynamic content
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.sectionId) {
      const section = document.getElementById('ingredients-list-' + event.detail.sectionId);
      if (section) {
        section.dataset.tabsInitialized = 'false';
        initIngredientsTabs('ingredients-list-' + event.detail.sectionId);
      }
    }
  });
}

